"use strict";

( () => {
	const $maps = document.querySelectorAll( ".google-map" );

	for ( const $map of $maps ) {
		$map.googleMap = new IM_Google_Map( $map );
	}
} )();
